// extracted by mini-css-extract-plugin
module.exports = {"magazine-card":"MagazineCard_magazine-card__heepO","information-wrapper":"MagazineCard_information-wrapper__SjFDI"};